import apiClient from '../api/apiClient';

function unwrap(res) {
  const body = res?.data;
  if (body && typeof body === 'object' && 'data' in body) return body.data;
  return body;
}

const dashboardService = {
  getScopeOptions: async () => {
    const response = await apiClient.get('/api/v1/admin/dashboard/scope-options');
    const data = unwrap(response);
    if (Array.isArray(data)) {
      return { options: data, viewer_scope: 'team' };
    }
    return {
      options: data?.options ?? [{ id: 'all', label: 'All' }],
      viewer_scope: data?.viewer_scope ?? 'team',
    };
  },

  getSummary: async ({ startDate, endDate, scopeUserId = 'all' } = {}) => {
    const response = await apiClient.get('/api/v1/admin/dashboard/summary', {
      params: {
        start_date: startDate,
        end_date: endDate,
        scope_user_id: scopeUserId,
      },
    });
    return unwrap(response);
  },
};

export default dashboardService;
